import { Box, Stack, Typography } from '@mui/material';
import {
  AccordionArrow,
  AccordionExpandIconBlue,
  AsyncButton,
  NewItemBadge,
  AccordionNumberedStepper,
  AdvancedSearchFilteredCategories,
  AdvancedSearchPaper,
  AdvancedSearchTitle,
  ControlledRadioButtons,
  ControlledAutocomplete,
  ButtonAction,
  BGCircle,
  CheckboxInput,
  ConfirmDeleteDialog,
  ContactUsMobile,
  ControlledErrorMessage,
  ControlledSelectInput,
  ControlledTextField,
  ControlledToggleButtons,
  ButtonLinkOrDownload,
} from 'Components';
import { OrderEquipment } from 'Images';
import { useState } from 'react';

export const TestComponents = () => {
  const [autocompleteValue, setAutocompleteValue] = useState('');
  const [radioValue, setRadioValue] = useState(false);
  const [checkboxInput, setCheckboxInput] = useState(false);
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false);
  const [controlledToggleButtons, setControlledToggleButtons] =
    useState('option 1');

  const hrStyle = { border: '1px solid #ccc', width: '100%' };

  // This is developer page that works only in development env
  if (process.env.NODE_ENV !== 'development') {
    window.location.href = '/';
  }

  return (
    <>
      <Stack spacing={5}>
        <Box textAlign='center'>
          <h1>Component Page</h1>
        </Box>
        <Box>
          <h4>ControlledAutocomplete</h4>
          <ControlledAutocomplete
            value={''}
            setValue={setAutocompleteValue}
            options={['test 1', 'test 2', 'test 3']}
            label={'רכיב השלמה אוטומטית'}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <h4>ControlledRadioButtons</h4>
          <ControlledRadioButtons
            isDirectionRow
            title={'כפתורי רדיו'}
            radioGroupSx={{ gap: '37px' }}
            values={['אפשרות ראשונה', 'אפשרות שנייה']}
            onChange={(value: string) =>
              setRadioValue(value === 'אפשרות שנייה')
            }
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <h4>ButtonAction</h4>
          <ButtonAction
            imageSrc={OrderEquipment}
            text={'שלח כעת'}
            callback={() => alert('clicked on ButtonAction')}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AccordionArrow</Typography>
          <AccordionArrow />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AccordionExpandIconBlue</Typography>
          <AccordionExpandIconBlue />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AccordionNumberedStepper</Typography>

          <AccordionNumberedStepper
            steps={['step 1', 'step 2', 'step 2', 'step 2', 'step 2', 'step 2']}
            title='Example'
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AdvancedSearchFilteredCategories</Typography>
          <AdvancedSearchFilteredCategories
            maxSingleSearchFieldsID={5}
            removeSearchCategory={() =>
              alert('executing remove search category')
            }
            resultNumber={2}
            searchCategories={[
              {
                value: 'value 1',
                searchValueID: 1,
                multiChoiceValue: [
                  { value: 'sub value 1.1', searchValueID: 1.1 },
                  { value: 'sub value 1.2', searchValueID: 1.2 },
                  { value: 'sub value 1.3', searchValueID: 1.3 },
                ],
              },
              {
                value: 'value 2',
                searchValueID: 2,
                multiChoiceValue: [
                  { value: 'sub value 2.1', searchValueID: 2.1 },
                  { value: 'sub value 2.2', searchValueID: 2.2 },
                  { value: 'sub value 2.3', searchValueID: 2.3 },
                ],
              },
              {
                value: 'value 3',
                searchValueID: 3,
                multiChoiceValue: [
                  { value: 'sub value 3.1', searchValueID: 3.1 },
                  { value: 'sub value 3.2', searchValueID: 3.2 },
                  { value: 'sub value 3.3', searchValueID: 3.3 },
                ],
              },
              {
                value: 'value 4',
                searchValueID: 4,
                multiChoiceValue: [],
              },
              {
                value: 'value 5',
                searchValueID: 5,
                multiChoiceValue: [],
              },
            ]}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AdvancedSearchPaper</Typography>
          <AdvancedSearchPaper
            closeAdvancedSearch={() => alert('executing close advanced search')}
          >
            Hello!
          </AdvancedSearchPaper>
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AdvancedSearchTitle</Typography>
          <AdvancedSearchTitle
            openAdvancedSearch={() => alert('executing open advanced search')}
            advancedSearchOpen={false}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <Typography>AsyncButton</Typography>
          <AsyncButton loading={true} />
        </Box>
        <hr style={hrStyle} />
        <Box>
          NewItemBadge
          <NewItemBadge />
        </Box>
        <hr style={hrStyle} />
        <Box position={'relative'}>
          BGCircle
          <BGCircle
            position={{ top: '0' }}
            diameterPX={25}
            bgColor={'#ec0000'}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          CheckboxItem
          <CheckboxInput
            checked={checkboxInput}
            label='example 1'
            onChange={() => setCheckboxInput(!checkboxInput)}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          ConfirmDeleteDialog
          <ConfirmDeleteDialog
            closeModal={() => setConfirmDeleteDialog(!confirmDeleteDialog)}
            deleteModal={() => alert('executing delete modal')}
            isVisible={confirmDeleteDialog}
            fileName='example'
          />
          <button onClick={() => setConfirmDeleteDialog(!confirmDeleteDialog)}>
            open ConfirmDeleteDialog
          </button>
        </Box>
        <hr style={hrStyle} />
        <Box>
          ContactUsMobile
          <ContactUsMobile
            description='Lorem ipsum dolor, sit amet consectetur adipisicing elit. Possimus reiciendis nulla tempore provident quidem consectetur ab sed? Porro, consequatur quia. Praesentium voluptatem nesciunt et, reiciendis autem eaque consequatur. Odit, architecto.'
            phoneNumber='054-054054'
            phoneNumberTel='059059059'
            title='title'
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <ControlledErrorMessage errorMsg='error!' />
        </Box>
        <hr style={hrStyle} />
        <Box>
          ControlledRadioButtons
          <ControlledRadioButtons
            title='title'
            values={['one', 'two', '3']}
            onChange={() => alert('executing change')}
            isDirectionRow={false}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <ControlledSelectInput
            label={'example'}
            options={['opt 1', 'opt 2', 'opt 3', 'opt 4', 'opt 5']}
            value={''}
            setValue={() => alert('executing set value')}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <ControlledTextField
            value={''}
            setValue={() => alert('executing set value')}
            error={null}
            setError={() => alert('executing set error')}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <ControlledToggleButtons
            onChange={(e, value) => setControlledToggleButtons(value)}
            value={controlledToggleButtons}
            option1Text={'option 1'}
            option2Text={'option 2'}
          />
        </Box>
        <hr style={hrStyle} />
        <Box>
          <ButtonLinkOrDownload label={'כפתור לדוגמה'} url={'/'} isDownload />
          <ButtonLinkOrDownload label={'רק כפתור'} url={'/'} />
        </Box>
        <hr style={hrStyle} />
        <Box></Box>
        <hr style={hrStyle} />
        <Box></Box>
        <hr style={hrStyle} />
        <Box></Box>
        <hr style={hrStyle} />
        <Box></Box>
        <hr style={hrStyle} />
      </Stack>
    </>
  );
};
